class CollectionSearchFeedback extends HTMLElement {
  connectedCallback() {
    this.reachedPage = Number.parseInt(this.dataset.page || '1', 10);
    this.isLastPage = this.dataset.lastPage === 'true';
    this.content = this.querySelector('.collection-search-feedback__content');
    this.checkEnd = this.checkEnd.bind(this);
    if (this.reachedPage >= 10 && this.isLastPage) this.watchEnd();
  }

  setReachedPage(page, isLastPage) {
    this.reachedPage = Math.max(this.reachedPage, page);
    this.isLastPage = isLastPage;
    if (this.reachedPage >= 10 && this.isLastPage) this.watchEnd();
    else this.stopWatching();
  }

  watchEnd() {
    if (this.watching || this.classList.contains('is-visible')) return;
    this.watching = true;
    window.addEventListener('scroll', this.checkEnd, { passive: true });
    window.addEventListener('resize', this.checkEnd);
    this.checkEnd();
  }

  checkEnd() {
    if (!this.isConnected || !this.isLastPage || this.classList.contains('is-visible')) return;
    const hasScrolled = window.scrollY > 0 || document.documentElement.scrollHeight <= window.innerHeight;
    const paginationLoading = this.closest('.section-collection-products-grid')?.querySelector('custom-pagination[loading]');
    if (!hasScrolled || paginationLoading || this.getBoundingClientRect().top > window.innerHeight - 48) return;
    this.content.hidden = false;
    this.classList.add('is-visible');
    this.closest('.section-collection-products-grid')?.classList.add('collection-feedback-visible');
    this.stopWatching();
  }

  stopWatching() {
    window.removeEventListener('scroll', this.checkEnd);
    window.removeEventListener('resize', this.checkEnd);
    this.watching = false;
  }

  disconnectedCallback() {
    this.stopWatching();
  }
}

if (!customElements.get('collection-search-feedback')) {
  customElements.define('collection-search-feedback', CollectionSearchFeedback);
}
